import { cn } from '@/_shared/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('animate-pulse rounded-md bg-grey-50', className)} {...props} />;
}

export { Skeleton };
